<template>
  <div id="vista-documento-pdf">
    <v-row class="secondary--text" justify="space-between" align="center">
      <h3>
        {{getTituloDocumento}}
      </h3>
      <custom-button
        v-if="rutaArchivo && !vistaSimple"
        @click.prevent="descargarPDf"
        tipo="agregar"
        label="Descargar PDF"
        class="my-2">
      </custom-button>
    </v-row>
    <v-row justify="center">
      <template v-if="rutaArchivo && progresoDescarga === 100">
        <VistaPreviaPdf
        :rutaArchivo="this.rutaArchivo"
        height="720"
        width="1200" />
      </template>
      <template v-else>
        <div>
          <v-progress-circular
            :size="100"
            :width="15"
            :value="progresoDescarga"
            color="blue darken-1"
            dark
          >
            <h3>{{ progresoDescarga }}</h3>
          </v-progress-circular>
        </div>
      </template>
    </v-row>
  </div>
</template>

<script>
import fileDownload from 'js-file-download';
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';
import CustomButton from '@/components/buttons/Button.vue';
import VistaPreviaPdf from '@/components/VistaPreviaPdf.vue';

export default {
  name: 'VerDocumentoPdf',
  mixins: [mixDescargarArchivo],
  props: {
    documentoPdfVer: {
      type: Object,
      required: true,
    },
    moduloOrigen: {
      type: String,
      required: false,
    },
    vistaSimple: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    VistaPreviaPdf,
    CustomButton,
  },
  data() {
    return {
      rutaArchivo: null,
      progresoDescarga: 0,
      archivoDescarga: null,

    };
  },
  methods: {
    descargarPDf() {
      fileDownload(this.archivoDescarga, this.getNombreDocumento);
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
  computed: {
    getTituloDocumento() {
      if (this.moduloOrigen === 'contratos') {
        return `${this.documentoPdfVer.documento.descripcion}${this.documentoPdfVer.referencia ? ' - ' : ''}${this.documentoPdfVer.referencia}`;
      }
      if (this.moduloOrigen === 'planeacion') {
        return this.documentoPdfVer.descripcion;
      }
      return '';
    },
    getNombreDocumento() {
      if (this.moduloOrigen === 'contratos') {
        return `${this.documentoPdfVer.contrato.numero}_${this.documentoPdfVer.documento.descripcion}${this.documentoPdfVer.referencia ? '_'
          : ''}${this.documentoPdfVer.referencia ? this.documentoPdfVer.referencia : ''}.pdf`;
      }
      if (this.moduloOrigen === 'planeacion') {
        return this.documentoPdfVer.descripcion;
      }
      return 'documento.pdf';
    },
  },
  mounted() {
    this.mixGetPdf(this.documentoPdfVer);
  },

};
</script>

<style>

</style>
